import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Badge,
  Button,
  Card,
  HStack,
  Input,
  NativeSelect,
  Separator,
  Stack,
  Text,
} from "@chakra-ui/react";
import { CardForm } from "../Components/custom/CardForm";
import { AddressForm } from "../Components/custom/AddressForm";
import { getAddressCard } from "../Redux/Action/auth/getAddressCardAction";
import { momumpayPayment, momumpayPayout, momumpayWithdrawalRequest } from "../Redux/Action";
import { getUserIP } from "../Utils/newHelper";
import { CardsSkeleton } from "../Components/custom/CardsSkeleton";

export const WithdrawalBank = () => {
  const [payload, setPayload] = useState(null);
  const [isCardDialogOpen, setIsCardDialogOpen] = useState(false);
  const [isAddressDialogOpen, setIsAddressDialogOpen] = useState(false);
  const [allAddress, setAllAddress] = useState([]);
  const [Allcards, setAllCards] = useState([]);
  const [defaultCardId, setDefaultCardId] = useState(null);
  const [defaultAddressId, setDefaultAddressId] = useState(null);
  const [defaultCardObj, setDefaultCardObj] = useState(null);
  const [defaultAddressObj, setDefaultAddressObj] = useState(null);
  const [isCardLoading, setIsCardLoading] = useState(true);
  const [IP, setIP] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    const stored = sessionStorage.getItem("withdrawalbank_payload");
    if (stored) {
      setPayload(JSON.parse(stored));
    }
    dispatch(
      getAddressCard({
        callback: (data) => {
          if (data?.meta?.code === 200) {
            setAllAddress(data?.data?.address);
            setAllCards(data?.data?.card);
            const defaultAddress = data?.data?.address?.find(
              (item) => item?.default
            );
            const defaultCard = data?.data?.card?.find((item) => item?.default);
            setDefaultCardObj(defaultCard);
            setDefaultCardId(defaultCard?._id);

            setDefaultAddressObj(defaultAddress);
            setDefaultAddressId(defaultAddress?._id);
            setIsCardLoading(false);
          }
        },
      })
    );

    const fetchIP = async () => {
      const ip = await getUserIP();
      setIP(ip);
    };

    fetchIP();
  }, []);

  const handleMonumpayGateway = () => {
    dispatch(
      momumpayPayout({
        amount: payload?.amount,
        addressId: defaultAddressId,
        cardId: defaultCardId,
        ip: IP,
        callback: (data) => {
          if (data?.meta?.code === 200) {
            console.log("Payment URL:", data?.data?.redirectUrl);
            
            // window.open(data?.data?.redirectUrl, "_blank");
          }
        },
      })
    );
  };

  const getCardEnding = (value) => {
    return value?.slice(-4);
  };

  const handleSelectionChange = (type, e) => {
    const selectedId = e?.target?.value;

    if (type === "card") {
      setDefaultCardId(selectedId);

      const selectedCard = Allcards?.find((card) => card._id === selectedId);
      setDefaultCardObj(selectedCard);
    }

    if (type === "address") {
      setDefaultAddressId(selectedId);

      const selectedAddress = allAddress?.find(
        (address) => address._id === selectedId
      );
      setDefaultAddressObj(selectedAddress);
    }
  };

  if (!payload)
    return (
      <Stack
        gap="4"
        align="center"
        maxW="md"
        margin="auto"
        borderRadius="10px"
        padding="3rem"
        boxShadow="rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;"
      >
        Invalid Request
      </Stack>
    );

  return (
    <Stack
      gap="4"
      align="center"
      maxW="md"
      margin="auto"
      borderRadius="10px"
      padding="3rem"
      boxShadow="rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;"
    >
      <HStack width="100%" justifyContent="space-between">
        <Button
          variant="surface"
          size="xs"
          width="45%"
          colorPalette="teal"
          onClick={() => setIsAddressDialogOpen(true)}
        >
          Add New Address
        </Button>
        <Button
          variant="surface"
          size="xs"
          width="45%"
          colorPalette="teal"
          onClick={() => setIsCardDialogOpen(true)}
        >
          Add New Card
        </Button>
      </HStack>
      <HStack width="100%">
        <NativeSelect.Root
          size="xs"
          width="50%"
          onChange={(e) => handleSelectionChange("address", e)}
        >
          <NativeSelect.Field placeholder="Select Address">
            {allAddress?.map((item) => (
              <option key={item?._id} value={item?._id}>
                {item?.address},{item?.region}
              </option>
            ))}
          </NativeSelect.Field>
          <NativeSelect.Indicator />
        </NativeSelect.Root>
        <NativeSelect.Root
          size="xs"
          width="50%"
          onChange={(e) => handleSelectionChange("card", e)}
        >
          <NativeSelect.Field placeholder="Select Card">
            {Allcards?.map((item) => (
              <option key={item?._id} value={item?._id}>
                Card ending with {getCardEnding(item?.pan)}
              </option>
            ))}
          </NativeSelect.Field>
          <NativeSelect.Indicator />
        </NativeSelect.Root>
      </HStack>
      <Separator size="lg" width="100%" />
      <Stack width="100%">
        {isCardLoading ? (
          <CardsSkeleton />
        ) : defaultAddressObj ? (
          <Card.Root size="sm">
            <Card.Body color="fg.muted">
              <Card.Title mt="2">
                <HStack justifyContent="space-between">
                  {defaultAddressObj?.address}
                  {defaultAddressObj?.default ? (
                    <Badge colorPalette="green" variant="surface" size="xs">
                      Default
                    </Badge>
                  ) : (
                    <Badge colorPalette="yellow" variant="surface" size="xs">
                      Set as Default
                    </Badge>
                  )}
                </HStack>
              </Card.Title>
              <Card.Description>
                {defaultAddressObj?.street} {defaultAddressObj?.region}
                <br />
                {defaultAddressObj?.city}, {defaultAddressObj?.state},{" "}
                {defaultAddressObj?.country}
              </Card.Description>
            </Card.Body>
          </Card.Root>
        ) : (
          <Card.Root size="sm">
            <Card.Body color="fg.muted">No Address Added</Card.Body>
          </Card.Root>
        )}
      </Stack>
      <Stack width="100%">
        {isCardLoading ? (
          <CardsSkeleton />
        ) : defaultCardObj ? (
          <Card.Root size="sm">
            <Card.Body color="fg.muted">
              <Card.Title>
                <HStack justifyContent="space-between">
                  {defaultCardObj?.holder}
                  {defaultCardObj?.default ? (
                    <Badge colorPalette="green" variant="surface" size="xs">
                      Default
                    </Badge>
                  ) : (
                    <Badge colorPalette="yellow" variant="surface" size="xs">
                      Set as Default
                    </Badge>
                  )}
                </HStack>
              </Card.Title>
              <Card.Description>
                {defaultCardObj?.pan
                  ? defaultCardObj.pan
                      .slice(0, -4)
                      .replace(/\d/g, "*")
                      .match(/.{1,4}/g)
                      ?.join("  ") +
                    "  " +
                    defaultCardObj.pan.slice(-4)
                  : ""}
              </Card.Description>
            </Card.Body>
            <Card.Footer justifyContent="space-between">
              <Text color="fg.muted">Expiry: {defaultCardObj?.expires}</Text>
            </Card.Footer>
          </Card.Root>
        ) : (
          <Card.Root size="sm">
            <Card.Body color="fg.muted">No Cards Added</Card.Body>
          </Card.Root>
        )}
      </Stack>

      <Button
        onClick={() => handleMonumpayGateway()}
        variant="surface"
        size="xs"
        colorPalette="teal"
      >
        Initiate Payment
      </Button>
      {isCardDialogOpen && (
        <CardForm
          isCardDialogOpen={isCardDialogOpen}
          setIsCardDialogOpen={setIsCardDialogOpen}
        />
      )}
      {isAddressDialogOpen && (
        <AddressForm
          isAddressDialogOpen={isAddressDialogOpen}
          setIsAddressDialogOpen={setIsAddressDialogOpen}
        />
      )}
    </Stack>
  );
};
